export default function Mission() {
  return (
    <div
      style={{
        width: "90rem",
        height: "51.5625rem",
        flexShrink: "0",
        background: "white",
        display: "inline-flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "flex-start",
          gap: "6.25rem",
          marginTop: "20rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "1rem",
            padding: "1.6875rem 1.75rem",
            flexDirection: "column",
            borderRadius: "0.625rem",
            background: "#EAF0E8",
          }}
        >
          <p
            style={{
              color: "var(--title-color, #22495F)",
              fontSize: "1.2rem",
              fontWeight: "500",
              letterSpacing: "0.12rem",
              textTransform: "uppercase",
            }}
          >
            our mission
          </p>
          <h3
            style={{
              color: "var(--title-color, #22495F)",
              fontSize: "1.68rem",
              fontWeight: "600",
              lineHeight: "2.52rem",
              width: "29.76rem",
              fontFamily: "Clash Display",
            }}
          >
            Our mission is to drive positive societal transformation in Africa
          </h3>
          <p
            style={{
              color: "var(--text-color, #374151)",
              fontSize: "1.25rem",
              fontWeight: "400",
              lineHeight: "2rem",
              width: "33.25rem",
              opacity: "0.699999988079071",
            }}
          >
            Our mission is to drive positive societal transformation in Africa
            by addressing unique challenges and empowering its people. We focus
            on enhancing access to quality education, improving healthcare
            outcomes, supporting national security, and fostering
            entrepreneurship through capacity-building and access to finance.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "1rem",
            padding: "1.6875rem 1.75rem",
            flexDirection: "column",
            borderRadius: "0.625rem",
            background: "#EAF0E8",
          }}
        >
          <p
            style={{
              color: "var(--title-color, #22495F)",
              fontSize: "1.2rem",
              fontWeight: "500",
              letterSpacing: "0.12rem",
              textTransform: "uppercase",
            }}
          >
            our Vision
          </p>
          <h3
            style={{
              color: "var(--title-color, #22495F)",
              fontSize: "1.68rem",
              fontWeight: "600",
              lineHeight: "2.52rem",
              width: "33.6875rem",
              fontFamily: "Clash Display",
            }}
          >
            To harness the rich diaspora experience for African empowerment in
            Africa
          </h3>
          <p
            style={{
              color: "var(--text-color, #374151)",
              fontSize: "1.25rem",
              fontWeight: "400",
              lineHeight: "2rem",
              width: "33.25rem",
              opacity: "0.699999988079071",
            }}
          >
            Our vision is to harness the rich diaspora experience for the
            empowerment of individuals and communities in AFRICA. Our vision is
            a transformed AFRICA, where every individual has access to quality
            education and healthcare, and feels secure in a prosperous and
            inclusive society. Together, we create a thriving and inclusive
            nation.
          </p>
        </div>
      </div>
    </div>
  );
}
